import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { SegmentChangeEventDetail } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PaginationClientSideOptions } from 'src/app/app/_component/pagination-client-side/pagination-client-side-options';
import { PaginationClientSideComponent } from 'src/app/app/_component/pagination-client-side/pagination-client-side.component';
import { PaginationColumn } from 'src/app/app/_component/pagination-client-side/pagination-column.class';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { Animations } from 'src/app/_helpers/animations';
import { globalHelper } from 'src/app/_helpers/global';
import { GetInvitationsQuery } from 'src/app/_models/invitations-request.model';
import { DateStiPipe } from 'src/app/_pipes/date-sti.pipe';
import { UserService } from 'src/app/_services';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { Company } from '../company/company.model';
import { CompanyService } from '../company/company.service';
import { EntryViewComponent } from './entry-view/entry-view.component';
import { InvitationFilterModalComponent } from './invitation-filter-modal/invitation-filter-modal.component';
import { InvitationViewComponent } from './invitation-view/invitation-view.component';
import { Device, Invitation, InvitationEntry } from './invitation.model';
import { InvitationService } from './invitation.service';
import { preventSwipeToClose } from 'src/app/_helpers/preventSwipeToClose';

@Component({
  selector: 'app-invitation',
  templateUrl: './invitation.page.html',
  styleUrls: ['./invitation.page.scss'],
  animations: [Animations.animeRotate, Animations.animeHeight],
})
export class InvitationPage implements OnInit {
  constructor(
    public invitationServ: InvitationService,
    private router: Router,
    public p: ThisPlatform,
    private userServ: UserService,
    public dic: DictionaryService,
    public activatedRoute: ActivatedRoute,
    public companyServ: CompanyService,
    public toastController: ToastController,
    public translateService: TranslateService,
    public modalCtrl: ModalController,
    private headerServ: HeaderService
  ) {}

  invitationAdd = false;
  invitations: Invitation[];
  invitationsFilter: Invitation[];
  invitationEntries: InvitationEntry[];
  invitationEntriesFilter: InvitationEntry[];
  devices: Device[];
  scanQrcode = false;
  value: string;
  displayError = false;
  invitationAll = false;
  invitationCompany = false;
  showLoader: boolean = true;
  page: string;
  defaultPage: string = 'mine';
  filterIdCompany: number;
  selectedDate: any = new Date();
  dayFrom: Date;
  dayTo: Date;
  showFilter: boolean = false;
  deviceId: number;
  invitationEnteriesSubsc: Subscription;
  showAllInvitations: boolean = false;

  resetFilter: boolean = false;
  showDropdown: boolean = false;

  datePipe = new DateStiPipe(this.userServ);

  actualSubscription: Subscription;

  componentRefInvitations: any = InvitationViewComponent;
  componentRefEntry: any = EntryViewComponent;
  columnsDefinitionInvitations: PaginationColumn[] = [
    {
      name: 'company',
      displayName: 'ADD_INVITATION.COMPANY',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.user && row.user.company ? row.user.company.name : '-';
      },
    },
    {
      name: 'host',
      displayName: 'INVITATION.HOST',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.user.firstName + row.user.lastName;
      },
    },
    {
      name: 'guests',
      displayName: 'INVITATION.GUESTS_NUMBER',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return (row.invitationGuests.length + row.invitationEmployees?.length);
      },
    },
    {
      name: 'title',
      displayName: 'INVITATION.INV_NAME',
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.title;
      },
    },
    {
      name: 'date',
      displayName: 'INVITATION.DATE',
      size: 2,
      sortable: true,
      colValue: (res) => {
        return new Date(
          this.datePipe.transform(res.dateStart, 'onlyDate', 'en') + ''
        );
      },
    },
    {
      name: 'time',
      displayName: 'INVITATION.TIME',
      size: 2,
      sortable: false,
      colValue: (res) => {
        return (
          this.datePipe.transform(res.dateStart, 'onlyHour') +
          '-' +
          this.datePipe.transform(res.dateEnd, 'onlyHour')
        );
      },
    },
  ];

  columnsDefinitionEntry: PaginationColumn[] = [
    {
      name: 'entry',
      displayName: 'INVITATION.ENTRY_DATE',
      size: 4,
      sizeXl: 3,
      sortable: true,
      colValue: (row) => {
        return row.date;
      },
    },
    {
      name: 'company',
      displayName: 'ADD_INVITATION.COMPANY',
      size: 1,
      sortable: true,
      colValue: (row) => {
        return row.qrcode.invitationGuest.invitation.user.idCompany;
      },
    },
    {
      name: 'user',
      displayName: 'INVITATION.HOST_USER',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.qrcode.invitationGuest.invitation.user.firstName;
      },
    },
    {
      name: 'guest',
      displayName: 'INVITATION.GUEST',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.qrcode.invitationGuest.fullname;
      },
    },
    {
      name: 'date',
      displayName: 'INVITATION.INVITATION_DATE',
      size: 3,
      sizeXl: 4,
      sortable: true,
      colValue: (row) => {
        return row.qrcode.invitationGuest.invitation.dateStart;
      },
    },
  ];

  optionsInvitations: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    overrideCountTranslation: 'ADD_INVITATION.INVITATIONS_',
    headerStickyPosition: 126,
    mobileViewBreakPoint: 1200,
    noResultsAddLink: '/app/invitation/add-invitation',
    addButtonText: 'INVITATION.BUTTON_ADD',
    permissionAdd: 'invitation.add',
    mobileFilterButton: true,
  };

  optionsEntries: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    overrideCountTranslation: 'ADD_INVITATION.ENTRIES_',
    headerStickyPosition: 122,
    mobileViewBreakPoint: 1200,
    mobileFilterButton: true,
  };

  rowsLoaderInvitations: RowsLoaderService;
  rowsLoaderEntries: RowsLoaderService;

  headerInit: HeaderModel = {
    segmentsChangeFunc: (event) => this.segmentChanged(event),
    userSettingsBreakpoint: 1250,
    segments: [
      {
        name: 'INVITATION.MY_INVITATION',
        value: 'mine',
        permissionKeys: ['invitation.view.mine'],
      },
      {
        name: 'INVITATION.COMPANY_INVITATION',
        value: 'company',
        permissionKeys: ['invitation.view.company'],
      },
      {
        name: 'INVITATION.ALL_INVITATION',
        value: 'all',
        permissionKeys: ['invitation.view.all'],
      },
      {
        name: 'INVITATION.RECEPTION',
        value: 'reception',
        permissionKeys: ['invitation.view.reception'],
      },
    ],
    title: 'INVITATION.INVITATION',
  };

  segmentsArray = [];

  @ViewChild('searchBar')
  searchBar;

  @ViewChild('invitationPagination')
  invitationPagination: PaginationClientSideComponent;

  async ngOnInit() {
    this.page = this.defaultPage;
    this.invitationServ.filterDetails.showAllInvitations = false;

    await this.invitationServ.getDevices(3); //  CONCIERGE = 3
    this.loadCompanies();
    this.invitationAdd = await this.userServ.hasRolesAsync(['invitation.add']);

    this.headerInit.segments.forEach((segment) => {
      if (this.userServ.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });

    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get('section')) {
        const page = params.get('section');
        if (this.segmentsArray.filter((el) => el == page).length > 0) {
          this.page = params.get('section');
          this.initInvitations(this.page);
        } else {
          this.page = this.segmentsArray[0];
          this.setQueryParam(this.segmentsArray[0]);
        }
      } else {
        this.page = this.segmentsArray[0];
        this.setQueryParam(this.segmentsArray[0]);
        this.headerServ.setHeaderInit(this.headerInit);
      }
    });
    this.setSortableMobile(this.page);

    this.invitationEnteriesSubsc = this.invitationServ
      .subscribeNotification()
      .subscribe((a) => {
        if (a.action === 'entry-created' && this.page == 'reception') {
          this.refreshEntries(true);
        }
      });

    this.actualSubscription = this.invitationServ.filterDetailsSubject.subscribe(
      (e) => {
        if (this.page === 'reception') {
          this.selectedDate = new Date(this.invitationServ.filterDetails.date);
          this.setTheDay(new Date(this.invitationServ.filterDetails.date));
          this.refreshEntries(false);
        } else {
          if (e) {
            this.onFilterCrtiterionChanged(
              this.invitationServ.currentDateCriterion
            );
          } else {
            this.refreshInvitations();
          }
        }
      }
    );
  }

  ionViewWillEnter() {
    const arrayOfTranslationKeys = this.invitationServ.filterDateCriteria.map(
      function (obj) {
        return obj.translationKey;
      }
    );

    this.translateService.get(arrayOfTranslationKeys).subscribe((resp) => {
      this.invitationServ.filterDateCriteria.forEach((elem) => {
        elem.name = resp[elem.translationKey];
      });
      this.showDropdown = true;
    });
    this.headerInit.activeSegment = this.page;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  ionViewDidLeave() {
    this.showDropdown = false;
  }

  setQueryParam(value) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { section: value },
      queryParamsHandling: 'merge', // remove to replace all query params by provided
    });
    this.page = value;

    this.setSortableMobile(this.page);
  }

  rowsLoaderInitInvitations() {
    if (this.rowsLoaderInvitations) {
      if (this.searchBar.ngModel) {
        this.invitationsFilter = this.invitations.filter((s) => {
          return (
            (
              s.user.email +
              ' ' +
              s.user.company.name +
              ' ' +
              s.user.firstName +
              ' ' +
              s.user.lastName +
              ' ' +
              s.invitationGuests.length +
              ' ' +
              s.invitationEmployees.length +
              ' ' +
              s.title +
              ' ' +
              this.datePipe.transform(s.dateStart) +
              ' ' +
              '- ' +
              this.datePipe.transform(s.dateEnd, 'onlyHour')
            )
              .toUpperCase()
              .includes(this.searchBar.ngModel.toUpperCase()) ||
            s.invitationGuests.filter((g) => {
              return (
                g.fullname + ' ' + 
                g.email + ' ' + 
                (g?.phoneNumber?.length > 0 ? g.phoneNumber : ' ') + ' ' + 
                ((g?.carSpace && g?.carPlate) ? (g?.carPlate + ' ' + (g?.carPlate.replace(/ /g, ""))) : ' ')
              )
                .toUpperCase()
                .includes(this.searchBar.ngModel.toUpperCase());
            }).length > 0
          );
        });
      } else {
        this.invitationsFilter = this.invitations;
      }
      this.rowsLoaderInvitations.init(this.invitationsFilter);
    }
  }

  rowsLoaderInitEntries() {
    if (this.rowsLoaderEntries) {
      if (this.searchBar.ngModel) {
        this.invitationEntriesFilter = this.invitationEntries.filter(
          (e: InvitationEntry) => {
            return (
              e.qrcode.invitationGuest.invitation.user.email +
              ' ' +
              e.qrcode.invitationGuest.email +
              ' ' +
              this.datePipe.transform(e.date) +
              ' ' +
              this.companyServ.getCompanyName(
                e.qrcode.invitationGuest.invitation.user.idCompany
              ) +
              ' ' +
              e.qrcode.invitationGuest.invitation.user.firstName +
              ' ' +
              e.qrcode.invitationGuest.invitation.user.lastName +
              ' ' +
              e.qrcode.invitationGuest.fullname +
              ' ' +
              this.datePipe.transform(
                e.qrcode.invitationGuest.invitation.dateStart
              ) +
              '-' +
              this.datePipe.transform(
                e.qrcode.invitationGuest.invitation.dateEnd,
                'onlyHour'
              )
            )
              .toUpperCase()
              .includes(this.searchBar.ngModel.toUpperCase());
          }
        );
      } else {
        this.invitationEntriesFilter = this.invitationEntries;
      }
      this.rowsLoaderEntries.init(this.invitationEntriesFilter);
    }
  }

  onFilterCrtiterionChanged(event) {
    this.invitationServ.currentDateCriterion = event;
    switch (event.id) {
      case 'all': {
        this.invitationServ.filterDetails.showAllInvitations = true;
        this.invitationServ.filterDetails.dateStart = null;
        this.invitationServ.filterDetails.dateEnd = null;
        break;
      }
      case 'future': {
        const today = new Date(Date.now());
        today.setHours(0, 0, 0, 0);
        this.invitationServ.filterDetails.showAllInvitations = false;
        this.invitationServ.filterDetails.dateStart = today;
        this.invitationServ.filterDetails.dateEnd = null;
        break;
      }
      case 'range': {
        this.invitationServ.filterDetails.showAllInvitations = false;
        this.invitationServ.filterDetails.dateStart = new Date();
        this.invitationServ.filterDetails.dateEnd = new Date();
        break;
      }
      default: {
        this.onFilterCrtiterionChanged(
          this.invitationServ.filterDateCriteria[0]
        );
      }
    }
    this.refreshInvitations();
  }

  refreshInvitations() {
    this.showLoader = true;
    this.invitationServ.filterDetailsShowLoader = true;

    let requestParams: GetInvitationsQuery = this.invitationServ.filterDetails
      .dateEnd
      ? {
          all: this.invitationServ.filterDetails.showAllInvitations,
          dateEndGreatherThan: null,
          dateStart: new Date(
            this.invitationServ.filterDetails.dateStart.setHours(0, 0, 0, 0)
          ).toISOString(),
          dateEnd: new Date(
            this.invitationServ.filterDetails.dateEnd.setHours(23, 59, 59, 999)
          ).toISOString(),
        }
      : {
          all: this.invitationServ.filterDetails.showAllInvitations,
          dateEndGreatherThan: new Date(
            this.invitationServ.filterDetails.dateStart
          ).toISOString(),
          dateStart: null,
          dateEnd: null,
        };
    if (this.invitationServ.filterDetails.companyId) {
      requestParams.idCompany = this.invitationServ.filterDetails.companyId;
    } else if (this.invitationCompany) {
      requestParams.idCompany = this.userServ.userStorage.idCompany;
    } else {
      requestParams.all = this.invitationAll;
    }

    this.invitationServ.getInvitations(requestParams).subscribe(
      (invitations: Invitation[]) => {
        this.invitations = this.invitationsFilter = invitations;
        this.invitationServ.invitationCount = invitations.length;
        this.rowsLoaderInitInvitations();
        this.showLoader = false;
        this.invitationServ.filterDetailsShowLoader = false;
      },
      (err) => {
        this.invitations = [];
        this.showLoader = false;
        this.invitationServ.filterDetailsShowLoader = false;
      }
    );
  }

  onChangeSearch() {
    if (this.page === 'reception') {
      this.rowsLoaderInitEntries();
    } else {
      this.rowsLoaderInitInvitations();
    }
  }

  onScanQr() {
    this.scanQrcode = true;
    this.value = '';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (!this.scanQrcode) return;

    if (event.key === 'Escape') {
      this.value = '';
      this.scanQrcode = false;
    }

    if (event.key === 'Enter') {
      try {
        this.invitationServ
          .getInvIdByQrcodeResponse(this.value.toLowerCase())
          .subscribe(
            (res) => {
              if (res.status === 200) {
                // jesli okej!
                let r: any = res.body;
                this.router.navigate([
                  `/invitation/edit-invitation/${r.idInvitation}`,
                ]);
                this.scanQrcode = false;
              } else {
                // Wyswietl blad, lub nie poprawny kod qr
                this.displayError = true;
              }
            },
            (err) => {
              this.displayError = true;
              this.value = '';
            }
          );
      } catch (err) {
        this.value = '';
      }

      this.value = '';
    }

    if (event.key === 'Shift') return;

    this.value += event.key;
  }

  hideOverlay() {
    this.scanQrcode = false;
  }

  segmentChanged(event: CustomEvent<SegmentChangeEventDetail>) {
    this.invitationServ.filterDetails.companyId = null;
    this.setQueryParam(event.detail.value);
  }

  async initInvitations(section) {
    await this.companyServ.loadCompaniesSync();
    this.getCompaniesForVirtualReception();
    this.invitationAll = false;
    this.invitationCompany = false;

    if (section === 'mine') {
    } else if (section === 'all') {
      this.invitationAll = true;
      this.invitationServ.filterDetails.showAllInvitations = true;
    } else if (section === 'company') {
      this.invitationCompany = true;
      this.invitationServ.filterDetails.showAllInvitations = true;
    }
    if (section === 'reception') {
      this.refreshEntries(false);
    } else {
      this.refreshInvitations();
    }
  }

  rowsLoaderServiceReadyInvitations(loader: RowsLoaderService) {
    this.rowsLoaderInvitations = loader;
  }

  rowsLoaderServiceReadyEntries(loader: RowsLoaderService) {
    this.rowsLoaderEntries = loader;
  }

  refreshEntries(fromSubscription) {
    this.showLoader = true;
    this.invitationServ.filterDetailsShowLoader = true;
    this.setTheDay(this.selectedDate);
    this.invitationServ
      .getInvitationEntries({
        idCompany: this.invitationServ.filterDetails.companyId,
        dateGretherThan: this.dayFrom.toISOString(),
        dateLessThan: this.dayTo.toISOString(),
        idDevice: this.invitationServ.filterDetails.deviceId,
      })
      .subscribe((res: InvitationEntry[]) => {
        this.showLoader = false;
        this.invitationServ.filterDetailsShowLoader = false;
        if (fromSubscription) {
          if (res.length > this.invitationServ.entriesCount) {
            globalHelper.PresentToast(
              this.toastController,
              this.translateService,
              'INVITATION.NEW_GUEST',
              5000
            );
          }
        }

        this.invitationEntries = res;
        this.rowsLoaderInitEntries();
        this.invitationServ.entriesCount = res.length;
      });
  }

  onFilterDate(date) {
    this.selectedDate = date;

    this.setTheDay(new Date(date));
    this.invitationServ.filterDetails.date = new Date(date).setHours(
      0,
      0,
      0,
      0
    );
    this.refreshEntries(false);
  }

  onFilterCompany($event) {
    if ($event) {
      this.invitationServ.filterDetails.companyId = $event.id;
    } else {
      this.invitationServ.filterDetails.companyId = null;
    }

    if (this.page == 'reception') {
      this.refreshEntries(false);
    } else {
      this.refreshInvitations();
    }
  }

  onFilterDevice($event) {
    if ($event) {
      this.invitationServ.filterDetails.deviceId = $event.id;
    } else {
      this.invitationServ.filterDetails.deviceId = null;
    }
    this.refreshEntries(false);
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
      component: InvitationFilterModalComponent,
      componentProps: {
        page: this.page,
      },
      canDismiss: preventSwipeToClose,
      cssClass: 'add-edit-modal mobile-filter__modal-container',
    });
    modal.present();
  }

  setTheDay(day: Date) {
    this.invitationServ.filterDetails.date = new Date(day).setHours(0, 0, 0, 0);

    this.dayFrom = new Date(new Date(day).setHours(0, 0, 0, 0));
    this.dayTo = new Date(new Date(day).setHours(23, 59, 0, 0));
  }

  ngOnDestroy() {
    this.invitationServ.filterDetails.showAllInvitations = false;
    this.invitationServ.filterDetails.companyId = null;
    this.invitationEnteriesSubsc.unsubscribe();
    this.showLoader = false;
    this.invitationServ.filterDetailsShowLoader = false;
  }

  setSortableMobile(section: string) {
    if (section === 'all') {
      return;
    } else if (section === 'mine') {
      this.columnsDefinitionInvitations.forEach((e) => {
        if (e.name === 'company' || e.name === 'host' || e.name === 'time') {
          e.sortableMobile = false;
        } else {
          e.sortableMobile = true;
        }
      });
    } else if (section === 'company') {
      this.columnsDefinitionInvitations.forEach((e) => {
        if (e.name === 'company' || e.name === 'time') {
          e.sortableMobile = false;
        } else {
          e.sortableMobile = true;
        }
      });
    } else {
      this.columnsDefinitionInvitations.forEach((e) => {
        e.sortableMobile = e.name === 'time' ? true : false;
      });
    }
    this.invitationPagination.ngOnInit();
  }

  loadCompanies() {
    this.companyServ.GetAll().subscribe((res: Company[]) => {
      this.companyServ.companies = res;
    });
  }

  getCompaniesForVirtualReception() {
    this.companyServ.companiesFilter = this.companyServ.companies.filter(
      (e) => e.visibleInVirtualReception !== false
    );
  }
}
